module.exports = __webpack_public_path__ + "static/media/UAP.7350f717.png";